import { Component, ElementRef, Renderer2 } from '@angular/core'
import { MbConstants } from '../../../../shared/mb-constants'
import { MbCheckoutTypes } from '../../../../models'
import { filter, tap } from 'rxjs/operators'
import { Order } from '@spartacus/order/root'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-order-details-totals',
  templateUrl: './mb-order-details-totals.component.html',
  styleUrls: ['./mb-order-details-totals.component.scss']
})
export class MbOrderDetailsTotalsComponent {

  mbCheckoutType = MbCheckoutTypes
  constants = MbConstants
  isPurchaseCheckout = false

  order$ = this.orderService.getOrderDetails().pipe(
    tap(order => {
      if (order?.totalItems === 0 || Object.keys(order).length === 0) {
        this.renderer.addClass(this.elem?.nativeElement, 'hide-submit-component')
      } else {
        this.renderer.removeClass(this.elem?.nativeElement, 'hide-submit-component')
      }
    }),
    filter(order => !!order && Object.keys(order).length !== 0),
    tap(order => {
      this.isPurchaseCheckout = order?.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_D ||
        order?.checkoutStatus?.checkoutType === this.mbCheckoutType.CHECKOUT_TYPE_E
    })
  )

  constructor (protected orderService: OrderHistoryService,
               protected elem: ElementRef,
               protected renderer: Renderer2) { }

  getTotalQuantityOfTypeOfItems (type: string, order: Order) {
    let counter: number = 0
    order?.entries?.forEach((mbEntry: any) => {
      if (mbEntry?.orderEntryType === type) {
        counter += +mbEntry?.quantity
      }
    })
    return counter
  }
}
